export default __webpack_public_path__ + "static/media/scheduled-new.43a548f7.svg";